// Re-export from shared panel components for backward compatibility
import { createPanelStore } from '../../../shared/components/panel';

// Create sites-specific panel store with custom storage key
const sitesPanelStore = createPanelStore({
  storageKey: 'sites-panel-storage',
  defaultWidth: 500,
  minWidth: 300,
  maxWidthPercent: 0.7,
  maxHistoryItems: 10,
});

// Export store and utilities
export const usePanelStore = sitesPanelStore.usePanelStore;
export const constrainPanelWidth = sitesPanelStore.constrainPanelWidth;
export const MIN_PANEL_WIDTH = sitesPanelStore.config.minWidth;
export const MAX_WIDTH_PERCENT = sitesPanelStore.config.maxWidthPercent;

// Re-export types for backward compatibility
export type {
  PanelHistoryItem as PanelItem,
  PanelStoreState as PanelState,
} from '../../../shared/components/panel';
